import { SplitText } from 'gsap/dist/SplitText';
import { forwardRef, useEffect, useRef } from 'react';
import type * as Polymorphic from '@radix-ui/react-polymorphic';
import { useInView } from 'react-intersection-observer';
import mergeRefs from 'react-merge-refs';
import { gsap } from 'react-scale/lib/gsap';
import { toVw } from 'react-scale/lib/util/math';

import s from './staggered-text.module.scss';

export const StaggeredText = forwardRef(
  ({ as: Comp, delay = 0, rootMargin = `0px 0px -15% 0px`, ...props }, ref) => {
    const gsapRef = useRef<HTMLHeadingElement>();
    const { ref: intersectionRef, inView } = useInView({
      rootMargin,
      threshold: 1,
      triggerOnce: true
    });

    useEffect(() => {
      if (!inView) return;

      const staggeredText = new SplitText(gsapRef.current, { type: 'lines' });
      new SplitText(gsapRef.current, { type: 'lines', linesClass: s['lines'] });

      gsap.fromTo(
        staggeredText.lines,
        {
          y: toVw(85),
          rotate: 3
        },
        {
          onStart: () => (gsapRef.current.style.visibility = 'visible'),
          y: 0,
          rotate: 0,
          stagger: 0.1,
          delay,
          duration: 0.55,
          ease: 'Power3.easeOut'
        }
      );
    }, [inView]);

    return <Comp ref={mergeRefs([ref, intersectionRef, gsapRef])} {...props} />;
  }
) as Polymorphic.ForwardRefComponent<'div', { delay?: number; rootMargin?: string }>;
